import { createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import useFetchAemBrspdContents from "../../../../../shared/hooks/useFetchAemBrspdContents";
import { errorConditionGTM } from "../../../Utils/googleTags";
import ApiUrls from "../../../Utils/axr";
type homeScreenContentDetailsInitialStateType = {
  homeScreenPageContent: any;
  loading: boolean;
  error: any;
  showRepairApmt: boolean;
  showUpcomingApmt: boolean;
};
const initialState: homeScreenContentDetailsInitialStateType = {
  homeScreenPageContent: null,
  loading: false,
  error: null,
  showRepairApmt: false,
  showUpcomingApmt: false,
};
const host = window?.location?.host;
const file = "home-page.json"

export const getHomeScreenPageContent = createAsyncThunk(
  "get/homeScreen-page/content",
  async () => {
    try {
      const response = await useFetchAemBrspdContents({
        [ApiUrls.aem_content]: `${file}?appName=${host}`,
      });
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

const homeScreenContentDetailSlice = createSlice({
  name: "homeScreen-page/Details",
  initialState,
  reducers: {
    addApmtPriority: (state, action) => {
      //state.rootToken = action.payload;
      state.showRepairApmt = action.payload.showRepairApmt;
      state.showUpcomingApmt = action.payload.showUpcomingApmt;
      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getHomeScreenPageContent.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getHomeScreenPageContent.fulfilled, (state, action) => {
      state.homeScreenPageContent = action.payload;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(getHomeScreenPageContent.rejected, (state, action) => {
      errorConditionGTM(
        "BRSPD_Fiber_EC_Flow",
        "Home Screen content",
        action.error?.message,
        action?.type
      );
      state.homeScreenPageContent = null;
      state.loading = false;
      state.error = action.error;
    });
  },
});
export const { addApmtPriority } = homeScreenContentDetailSlice.actions;
export default homeScreenContentDetailSlice.reducer;
